import {useLogger, useUniversalFetch, useUniversalPost} from '#imports';

async function useGetWebPref<T = string>(webPrefId: string, {identityId}: {identityId?: string} = {}): Promise<T | undefined> {
    const logger = useLogger();

    let endpoint = `/api/webpref/${webPrefId}`;
    if (identityId) {
        endpoint += `?identityId=${identityId}`;
    }

    let result;
    try {
        result = await useUniversalFetch<T>(endpoint);
    } catch (e: unknown) {
        logger.error(`Error while checking webpref "${webPrefId}": ${e instanceof Error ? e.message : undefined}`);
    }
    return result;
}

async function useSetWebPref(webPrefId: string, value: string | boolean | object): Promise<void> {
    const logger = useLogger();
    const endpoint = `/api/webpref/${webPrefId}`;

    try {
        if (typeof value === 'boolean' || typeof value === 'string') {
            await useUniversalPost(endpoint, {query: {value}});
        }
        if (typeof value === 'object') {
            await useUniversalPost(endpoint, {body: value});
        }
    } catch (e: unknown) {
        logger.error(`Error while setting webpref "${webPrefId}": ${e instanceof Error ? e.message : undefined}`);
    }
}

function createWebPreferencesApi() {
    return {
        getWebPref: useGetWebPref,
        setWebPref: useSetWebPref,
    };
}

export {createWebPreferencesApi as useWebPreferences};
